<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="450")

    template(v-slot:activator="{ on, attrs }")
      v-icon(
          slot="activator" 
          class="mr-2"
          small 
          title='Copy IM' 
          color="orange" 
          v-bind="attrs"
          v-on="on"
        ) filter_none

    v-card(class="pa-4")
      v-card-title(class="headline") Copy IM
      v-card-text are you sure you want to continue ?

      v-card-actions(class="mt-5")
        v-spacer

        v-btn(
            @click="dialog = false"
            class="custom__padding-btn elevation-0 mr-2"
        ) NO

        v-btn(
            color="blue-secondary",
            @click="submit()"
            class="elevation-0 custom__padding-btn"
        ) YES

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )

</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: 'CopyIM',
  props: {
    imNo: String,
    imType: Number,
  },
  data: () => ({
    dialog: false,
    overlay: false
  }),
  methods: {
    submit() {
        axios
        .post(process.env.VUE_APP_API_OLD+`/api/duplicateRequest`, { _id: this.imNo })
        .then(resp => {
          if (this.imType == 6) this.$router.push(`/memo-payment/edit/${resp.data.insertedId}/copyIM`);
          else if (this.imType == 7) this.$router.push(`/memo-announcement/edit/${resp.data.insertedId}/copyIM`);
          else this.$router.push(`/memo/edit/${resp.data.insertedId}`);
        }).catch((err) => {
            this.$toasted.error(err.response.error, { icon: 'error' });
            this.dialog = false
        });
    }
  }
};
</script>

<style>
    i.notif{
        margin-left: 1rem;
        font-size: 50px !important;
        color: #1976D2 !important;
    }
</style>